var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8927 0.471527C19.6185 0.471527 25.0704 5.92348 25.0704 12.6492C25.0704 19.375 19.6185 24.8269 12.8927 24.8269C6.16701 24.8269 0.715057 19.375 0.715057 12.6492C0.715057 5.92348 6.16701 0.471527 12.8927 0.471527ZM12.8927 2.90707C10.309 2.90707 7.83101 3.93347 6.00401 5.76048C4.177 7.58748 3.1506 10.0654 3.1506 12.6492C3.1506 15.233 4.177 17.711 6.00401 19.538C7.83101 21.365 10.309 22.3914 12.8927 22.3914C15.4765 22.3914 17.9545 21.365 19.7815 19.538C21.6085 17.711 22.6349 15.233 22.6349 12.6492C22.6349 10.0654 21.6085 7.58748 19.7815 5.76048C17.9545 3.93347 15.4765 2.90707 12.8927 2.90707ZM12.8927 5.3426C13.191 5.34264 13.4789 5.45215 13.7018 5.65035C13.9247 5.84856 14.0671 6.12167 14.102 6.41789L14.1105 6.56037V12.1451L17.407 15.4416C17.6254 15.6607 17.7522 15.9548 17.7617 16.264C17.7711 16.5733 17.6625 16.8745 17.4579 17.1066C17.2532 17.3387 16.9679 17.4841 16.6599 17.5135C16.3519 17.5428 16.0443 17.4538 15.7996 17.2646L15.6851 17.1635L12.0318 13.5102C11.8425 13.3208 11.721 13.0742 11.6859 12.8087L11.675 12.6492V6.56037C11.675 6.2374 11.8033 5.92766 12.0317 5.69928C12.26 5.4709 12.5698 5.3426 12.8927 5.3426Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIco);
export default __webpack_public_path__ + "static/media/clock_ico.219ed9a95c83a43313180d09e004cfb7.svg";
export { ForwardRef as ReactComponent };